import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontSizeService } from '../../services/font-size.service';

@Component({
  selector: 'app-font-size-toggle',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule
  ],
  template: `
    <div class="font-size-toggle">
      <button
        mat-icon-button
        (click)="fontSizeService.decrease()"
        [disabled]="!fontSizeService.canDecrease()"
        matTooltip="Diminuir tamanho da fonte"
        [attr.aria-label]="'Diminuir tamanho da fonte'"
        class="font-size-button">
        <mat-icon>text_decrease</mat-icon>
      </button>

      <button
        mat-icon-button
        (click)="fontSizeService.increase()"
        [disabled]="!fontSizeService.canIncrease()"
        matTooltip="Aumentar tamanho da fonte"
        [attr.aria-label]="'Aumentar tamanho da fonte'"
        class="font-size-button">
        <mat-icon>text_increase</mat-icon>
      </button>
    </div>
  `,
  styles: [`
    .font-size-toggle {
      display: inline-flex;
      align-items: center;
    }

    .font-size-button {
      transition: transform 0.2s ease;
    }

    .font-size-button:hover {
      transform: scale(1.1);
    }
  `]
})
export class FontSizeToggleComponent {
  readonly fontSizeService = inject(FontSizeService);
}